export const SESSION_TYPES = {
  online: {
    id: 'video',
    title: 'Video',
    tag: 'video'
  },
  inPerson: {
    id: 'in_person',
    title: 'In-person',
    tag: 'in_person'
  },
  both: {
    id: 'both',
    title: 'Both',
    tag: 'both'
  }
} as const;

export const SESSION_FORMAT_OPTIONS = [
  { label: SESSION_TYPES.online.title, title: SESSION_TYPES.online.title, tag: SESSION_TYPES.online.tag },
  { label: SESSION_TYPES.inPerson.title, title: SESSION_TYPES.inPerson.title, tag: SESSION_TYPES.inPerson.tag },
  { label: SESSION_TYPES.both.title, title: SESSION_TYPES.both.title, tag: SESSION_TYPES.both.tag },
] as const;

export const BOTH_SESSION_VALUES = [
  { title: SESSION_TYPES.online.title, tag: SESSION_TYPES.online.tag },
  { title: SESSION_TYPES.inPerson.title, tag: SESSION_TYPES.inPerson.tag },
] as const;
